<template>
  <div class="table-responsive">
    <table class="table custom-table mb-0" v-if="projects.length > 0">
      <thead>
        <tr>
          <th>Project Name</th>
          <th>Progress</th>
          <th class="text-end">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, key) in projects" :key="key">
          <td>
            <h2>
              <router-link :to="'project-view/' + item?.project_id">{{
                item.project_name
              }}</router-link>
            </h2>
            <small class="block text-ellipsis">
              <span>{{ getOpenTask(item?.task_details) }}</span>
              <span class="text-muted">open tasks, </span>
              <span>{{ getCompletedTask(item?.task_details) }}</span>
              <span class="text-muted ms-1">tasks completed</span>
            </small>
          </td>
          <td>
            <div class="progress progress-xs progress-striped">
              <div
                :class="
                  'progress-bar w-' +
                  getCompletedTaskPersentage(item?.task_details)
                "
                role="progressbar"
                data-bs-toggle="tooltip"
                :title="getCompletedTaskPersentage(item?.task_details) + '%'"
              ></div>
            </div>
          </td>
          <td class="text-end">
            <div class="dropdown dropdown-action">
              <a
                href="javascript:;"
                class="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                ><i class="material-icons">more_vert</i></a
              >
              <div class="dropdown-menu dropdown-menu-right">
                <router-link
                  class="dropdown-item"
                  :to="'project-view/' + item?.project_id"
                  ><i class="fa-solid fa-eye m-r-5"></i> view</router-link
                >
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else class="text-center p-2">
      <div class="ant-empty-image">
        <svg
          width="64"
          height="41"
          viewBox="0 0 64 41"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g transform="translate(0 1)" fill="none" fill-rule="evenodd">
            <ellipse fill="#f5f5f5" cx="32" cy="33" rx="32" ry="7"></ellipse>
            <g fill-rule="nonzero" stroke="#d9d9d9">
              <path
                d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
              ></path>
              <path
                d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                fill="#fafafa"
              ></path>
            </g>
          </g>
        </svg>
      </div>
      <p style="color: #00000040; margin-bottom: 0px">No data</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {},
  props: {
    project: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    projects() {
      return this.project.slice(0, 5) || [];
    },
  },
  methods: {
    getCompletedTask(task) {
      return (
        task?.filter((task) => task.task_status === "Completed")?.length || 0
      );
    },
    getOpenTask(task) {
      return (
        task?.filter((task) => task.task_status != "Completed")?.length || 0
      );
    },
    getCompletedTaskPersentage(task) {
      if (task === 0) return 0;
      return Math.round((this.getCompletedTask(task) / task?.length) * 100);
    },
  },
};
</script>
